import { render, staticRenderFns } from "./star-display.vue?vue&type=template&id=2283565e&"
import script from "./star-display.vue?vue&type=script&lang=js&"
export * from "./star-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2283565e')) {
      api.createRecord('2283565e', component.options)
    } else {
      api.reload('2283565e', component.options)
    }
    module.hot.accept("./star-display.vue?vue&type=template&id=2283565e&", function () {
      api.rerender('2283565e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z3UWBOL9XJQS/JS/comp/star-display.vue"
export default component.exports